import React from 'react';

function Afiliado() {
  return (
    <div>
      <h1>Afiliado Panel</h1>
      {/* Aquí va el código del panel del afiliado */}
    </div>
  );
}

export default Afiliado;
